<template>
    <article>
        <a href="#" @click="showModal">
            <span class="title">
                <span>{{ item.title }}</span><br>
                {{ item.data.description }}
            </span>
            <span class="material-icons">play_circle_outline</span>
            <span class="time">{{ item.data.time }} min</span>
        </a>
        <AudioPlayerPopUp
            v-show="isModalVisible"
            @close="closeModal"
        >
            <audio controls>
                <source :src="item.files[0].url" type="audio/mpeg">
            </audio>
        </AudioPlayerPopUp>
    </article>
</template>

<script>
    import AudioPlayerPopUp from './AudioPlayerPopUp.vue';
    export default {
        props: [
            "item"
        ],
        data () {
            return {
                isModalVisible: false
            }
        },
        components:{
            AudioPlayerPopUp
        },
        mounted () {},
        methods: {
            showModal(e) {
                e.preventDefault();
                this.isModalVisible = true;
                this.stopAudio();
            },
            closeModal() {
                this.isModalVisible = false;
                this.stopAudio();
            },
            stopAudio() {
                var sounds = document.getElementsByTagName('audio');
                for(var i=0; i<sounds.length; i++) {
                    sounds[i].pause();
                    sounds[i].currentTime = 0;
                }
            }
        }
    }
</script>





// WEBPACK FOOTER //
// resources/assets/frontend/js/components/AudioPlayer.vue